/**
 * @generated SignedSource<<eb0714f87fb76f4c12f0d9e2663fc6ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSurveyDemographicInformationFragment_demographicProfileUrl$data = {
  readonly demographicProfileUrl: string | null;
  readonly profilerUrl: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMoreSurveysBannerQuery_profileUrlRef">;
  readonly " $fragmentType": "useSurveyDemographicInformationFragment_demographicProfileUrl";
};
export type useSurveyDemographicInformationFragment_demographicProfileUrl$key = {
  readonly " $data"?: useSurveyDemographicInformationFragment_demographicProfileUrl$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSurveyDemographicInformationFragment_demographicProfileUrl">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSurveyDemographicInformationFragment_demographicProfileUrl",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "demographicProfileUrl",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMoreSurveysBannerQuery_profileUrlRef"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilerUrl",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7622606d1b3609f911d44889727cc597";

export default node;
